class Store {
  constructor() {
    this.persistStore = false;

    this.form = {
      items: [],
      shopping_location: null,
      address: null,
      account_id: null,
      customer_to_collect: true,
      remarks: null,
      customer_reference: null,
      contact_number: null,
      notification_contact_number: null,
      isCustomer: false,
    }

    this.http = null
    this.itemQtyCount = {}
    this.warningMessage = null
  }

  setHttpClient(http) {
    this.http = http
  }

  reloadCart(shoppingLocation = null) {
    if(!shoppingLocation) {
      if(!this.form.shopping_location) {
        this.form.shopping_location = localStorage.getItem('store.location')
      }
    } else {
      this.form.shopping_location = shoppingLocation
    }

    this.fetchCartFromCloud()
  }


  resetForm() {
    this.clearCloudCart()
  }


  syncToLocalStorage() {
    localStorage.setItem('store.location', JSON.stringify(this.form.shopping_location))
  }

  fetchCartFromCloud()
  {
    if(this.http) {
      this.http.get(window.route('customer.cart-data'), {params:{location: this.form.shopping_location}}).then(response => {
        this.form.items = response.data.items
        localStorage.setItem('cart_updated_at', response.data.updated_at)
      })
    }
  }

  pushCartToCloud() {
    if(this.http) {

      if(this.form.items.length > 0) {
        let payload = {
          items: this.form.items.map(item =>  {
            return {
              item_code: item.item_code,
              qty: item.qty,
              unit: item.unit
            }
          }),
          updated_at: localStorage.getItem('cart_updated_at') || null
        }

        this.http.post(window.route('customer.cart-data.sync'), payload).then(response => {
          localStorage.setItem('cart_updated_at', response.data.updated_at)
        })
      } else {
        this.clearCloudCart()
      }

    }
  }

  clearCloudCart() {
    if(this.http) {
      this.http.get(window.route('customer.cart-data.clear')).then(() => {
        this.form.items = []
        this.form.account_id = null
      })
    }
  }

  // finds the total qty already in the cart for the same id
  qtyForItemUnit(item_code, unit) {
    let item = this.form.items.find(itm  => itm.item_code === item_code && itm.unit === unit)
    if (item) {
      return item.qty
    }
    return 0;
  }

  // finds the total qty already in the cart for the same id
  totalQtyInUnit(id, unit) {
    let items = this.form.items.filter(itm  => itm.product.id === id)
    let counter = 0

    items.forEach(item => {
      if(item.product.base_unit === item.unit) {
        // item is in base unit
        //if item unit is same as required unit
        if(unit === item.unit)
        {
          counter += item.qty
        } else {
          let baseUnitRate = item.product.units[unit].unit_rate
          counter += item.qty / baseUnitRate
        }

      } else {
        // item is not in base unit
        if(unit === item.product.base_unit) {
          // item unit is not base unit and required unit is the item base unit
          let baseUnitRate = item.product.units[item.unit].unit_rate
          counter += item.qty * baseUnitRate
        } else {
          counter += item.qty
        }
      }
    })

    return counter
  }

  setCustomerMode() {
    this.form.isCustomer = true
  }

  // form() {
  //   return this.form
  // }

  updateQty(item) {

    if (item.qty === 0) {
      this.removeItem(item)
    } else {
      if (this.form.isCustomer) {

        const lastLoadedQty = this.qtyForItemUnit(item.item_code, item.unit)

        // check if minimum quantity rule must be applied
        if(item.product.min_order_quantity > 0) {
          if(item.unit === item.product.base_unit) {
            if(item.qty < item.product.min_order_quantity) {
              if(lastLoadedQty  === 0) {
                item.qty = item.product.min_order_quantity
              }

              if(lastLoadedQty  >= item.product.min_order_quantity) {
                item.qty = 0
              }
            }
          } else {
            //convert min quantity to item units
            let unitRate =  item.product.units[item.unit].unit_rate
            let minUnitsInItemUnits = Math.floor(item.product.min_order_quantity / unitRate)

            if(item.qty < minUnitsInItemUnits) {
              if(lastLoadedQty  === 0) {
                item.qty = minUnitsInItemUnits
              }

              if(lastLoadedQty  >= minUnitsInItemUnits) {
                item.qty = 0
              }
            }
          }
        }

        const totalQtyLoaded =  this.totalQtyInUnit(item.product.id, item.unit)
        let diffInQty = item.qty - lastLoadedQty
        let nextTotalQty = Math.floor(diffInQty + totalQtyLoaded)

        // check if maximum order quantity rule must be applied
        if(item.product.max_order_quantity > 0) {

          if(item.unit === item.product.base_unit) {
            if(lastLoadedQty < item.qty) {
              if(nextTotalQty > item.product.max_order_quantity) {
                item.qty = lastLoadedQty
              }
            }

          } else {
            //convert max quantity limit to item units
            let unitRate =  item.product.units[item.unit].unit_rate
            let maxUnitsInItemUnits = Math.floor(item.product.max_order_quantity / unitRate)

            if(lastLoadedQty < item.qty) {
              if(nextTotalQty > maxUnitsInItemUnits) {
                item.qty = lastLoadedQty
              }
            }
          }
        }



        const availableQty = item.product.units[item.unit].available
        diffInQty = item.qty - lastLoadedQty
        nextTotalQty = Math.floor(diffInQty + totalQtyLoaded)

        // check if the qty is not exceeding the available base unit
        if(availableQty < nextTotalQty)
        {
          //nextTotalQTY is not available
          if(totalQtyLoaded <= availableQty) {
            item.qty = lastLoadedQty
          } else {
            item.qty = 0
          }
        }

        this.commit(item)
        if(item.qty === 0) {
          this.removeItem(item)
        }


      } else {
        this.commit(item)
      }

      this.updateTotalFor(item)
    }
  }

  commit(item) {
    let row = this.form.items.find(itm => itm.product.item_code === item.product.item_code && itm.unit === item.unit)

    if (row) {
      row.qty = item.qty
    } else {

      row = {...item, qty: item.qty}

      this.form.items.push(row)
    }

    // this.syncToLocalStorage();
    this.pushCartToCloud();
  }

  removeItem(item) {
    let row = this.form.items.find(itm => itm.product.item_code === item.product.item_code && itm.unit === item.unit)

    if (row) {
      let index = this.form.items.indexOf(row)
      this.form.items.splice(index, 1)
      // this.syncToLocalStorage();

      this.pushCartToCloud()

    }
  }

  updateTotalFor(item) {
    let items = this.form.items.filter(itm => itm.product.id === item.product.id)

    let qty = 0;

    items.forEach(itm => {
      let unitToBase = itm.product.units[itm.unit].unit_rate

      qty = qty + parseFloat((itm.qty * unitToBase).toFixed(2))
    })

    this.itemQtyCount[item.product.id] = qty

  }

}
const store = new Store()
export default store
